import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { admin } = useAuth();
    const location = useLocation();

    if (admin === null) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center bg-ink-900 text-cream/60 text-sm tracking-widest uppercase"
            >
                Verifica accesso…
            </div>
        );
    }
    if (!admin) {
        return (
            <Navigate
                to="/admin/login"
                state={{ from: location.pathname }}
                replace
            />
        );
    }
    return children;
}
